import {Component, Input} from '@angular/core';
import {TagInterface} from '../../../interfaces/tag/tag';
import {Utils} from '../../../classes/Utils';
import {DomSanitizer} from '@angular/platform-browser';
import {ColorType, IconType} from '../fe-icon/fe-icon.component';

@Component({
  selector: 'fe-tag',
  templateUrl: './fe-tag.component.html',
  styleUrls: ['./fe-tag.component.scss']
})
export class FeTagComponent {
@Input() tag: TagInterface;
@Input() keywords: Array<string>;
@Input() leadMode: boolean = false;
// Tag « Décision administrative » : style des autres tags, précédé d'un marteau
@Input() decisionMode: boolean = false;
  protected readonly Utils = Utils;
  protected readonly IconType = IconType;
  protected readonly ColorType = ColorType;

  constructor(public sanitizer: DomSanitizer) {
  }
}
